// extracted by mini-css-extract-plugin
export default {"FormControl":"get-project-items-block-module__FormControl--c87Zt","Box":"get-project-items-block-module__Box--bQSBd"};